// extracted by mini-css-extract-plugin
export var layoutContainer = "_e6-0";
export var layoutContainerNoRounding = "_e6-6";
export var layoutContainerOpen = "_e6-5";
export var layoutContainerResizing = "_e6-1";
export var mainContent = "_e6-2";
export var resizeDivider = "_e6-3";
export var slidePanel = "_e6-4";